import type { CSSObject } from '@emotion/react'
import { Color, OppositeTheme, Spacing, Typography } from '@opallabs/gem'
import type { StyleProps } from '../types'

export const container: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  marginBlockStart: Spacing.S,
}

export const button = ({ theme }: StyleProps): CSSObject => ({
  color: Color[theme].Surface.N999,

  '@media (prefers-contrast: more)': {
    color: Color[OppositeTheme[theme]].Surface.N000,
  },
})

export const text = ({
  clickable,
  theme,
}: StyleProps & {
  clickable: boolean
}): CSSObject => ({
  color: Color[theme].Text.Default,
  ...Typography.T500,
  cursor: clickable ? 'pointer' : 'default',
  display: 'flex',
  marginInline: Spacing.S,
})
